import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const TamanoEstructuraFormGroup = ({ iError, iTouched, fIsSubmitting, label, name }) => {
  return (
    <Form.Group>
      <Form.Label text={label} htmlFor={`input-${name}`} md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name={name}>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id={`input-${name}`}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TamanoEstructuraFormGroup)
